import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/HomepageS1.css";

export default function HomepageS1() {
  const trustItems = [
    "Governance-led advisory",
    "Customized learning",
    "Digital and immersive innovation",
    "Global research and engineering collaboration",
  ];

  return (
    // HOMEPAGE SECTION 1
    <section
      id="homepage-section-one"
      className="homepage-s1"
      aria-labelledby="homepage-s1-title"
    >
      {/* <div className="homepage-s1-background" aria-hidden="true"></div> */}

      <div className="homepage-s1-container">
        {/* <p className="homepage-s1-kicker">
          GalaxyEDGE Safety Inc.
        </p> */}

        <h2 id="homepage-s1-title" className="homepage-s1-title">
          Safety Engineered for Performance
        </h2>

        <p className="homepage-s1-description">
          GalaxyEDGE Safety Inc. helps organizations strengthen how safety is
          governed, designed, learned, and improved. We connect executive
          leadership, operational risk, workforce capability, and emerging
          technology to build safer, smarter, and more resilient workplaces.
        </p>

        <div className="homepage-s1-actions">
          <NavLink
            to="/contact"
            className="homepage-s1-button homepage-s1-primary"
          >
            Start a Conversation
          </NavLink>

          {/* <NavLink
            to="/solutions"
            className="homepage-s1-button homepage-s1-secondary"
          >
            Explore Our Capabilities
          </NavLink> */}
        </div>

        {/* <div
          className="homepage-s1-trust-grid"
          aria-label="GalaxyEDGE Safety capabilities"
        >
          {trustItems.map((item) => (
            <div className="homepage-s1-trust-item" key={item}>
              <span className="homepage-s1-trust-marker" aria-hidden="true"></span>
              <p>{item}</p>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
}